<template>
  <v-dialog
    :value="value"
    persistent
    max-width="320"
  >
    <v-card light>
      <!-- Do not use the v-card-title component because it breaks the words -->
      <v-card-text
        class="text-h6 black--text pt-4"
        v-text="title"
      />
      <v-card-text
        v-for="(str, i) in texts"
        :key="i"
        v-text="str"
      />
      <v-card-actions>
        <v-btn
          text
          color="grey darken-2"
          @click="$emit('no')"
          v-text="__(no)"
        />
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="$emit('yes')"
          v-text="__(yes)"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      I18n,
    ],

    props: {
      value: {
        required: true,
        type: Boolean,
      },
      title: {
        required: true,
        type: String,
      },
      text: {
        required: false,
        type: [Array, String],
      },
      yes: {
        required: false,
        type: String,
        default: 'yes',
      },
      no: {
        required: false,
        type: String,
        default: 'no',
      },
    },

    computed: {
      texts () {
        return Array.isArray(this.text) ? this.text : Array.of(this.text)
      },
    },
  }
</script>
